import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './AreasManagerModal.css';

export default function AreasManagerModal({ open, areas = [], onClose, onCreate, onUpdate, onDelete, busy = false }) {
    if (!open) return null;

    const panel = (
        <div className="roster-modal-backdrop" role="presentation" onClick={onClose}>
            <div
                className="glass-card roster-modal-panel animate-in"
                role="dialog"
                aria-modal="true"
                aria-labelledby="areas-modal-title"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="areas-modal-head">
                    <div>
                        <h3 id="areas-modal-title">Áreas de la empresa</h3>
                        <p className="text-sm text-muted areas-modal-sub">
                            Crea, renombra o elimina áreas. No se puede borrar un área con colaboradores asignados.
                        </p>
                    </div>
                    <button type="button" className="btn btn-secondary btn-sm" onClick={onClose} aria-label="Cerrar">
                        Cerrar
                    </button>
                </div>

                <AreaEditor label="Nueva área" placeholder="Ej. Producción, Logística…" onSave={onCreate} busy={busy} />

                <div className="areas-modal-list">
                    {areas.length === 0 ? (
                        <p className="text-muted text-sm text-center py-md">No hay áreas. Crea al menos una para dar de alta personal.</p>
                    ) : (
                        areas.map((a) => (
                            <AreaRow
                                key={a.id}
                                area={a}
                                onUpdate={onUpdate}
                                onDelete={onDelete}
                                busy={busy}
                            />
                        ))
                    )}
                </div>
            </div>
        </div>
    );

    return ReactDOM.createPortal(panel, document.body);
}

function AreaEditor({ label, placeholder, onSave, busy }) {
    const [name, setName] = useState('');

    const submit = async (e) => {
        e.preventDefault();
        const trimmed = name.trim();
        if (!trimmed) return;
        await onSave(trimmed);
        setName('');
    };

    return (
        <form className="areas-modal-add" onSubmit={submit}>
            <label>{label}</label>
            <div className="areas-modal-add-row">
                <input
                    className="input"
                    placeholder={placeholder}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    disabled={busy}
                />
                <button type="submit" className="btn btn-primary" disabled={!name.trim() || busy}>
                    Añadir
                </button>
            </div>
        </form>
    );
}

function AreaRow({ area, onUpdate, onDelete, busy }) {
    const [editing, setEditing] = useState(false);
    const [name, setName] = useState(area.name);
    const count = area.total_employees ?? area.employee_count;

    useEffect(() => {
        setName(area.name);
    }, [area.name]);

    const save = async () => {
        const trimmed = name.trim();
        if (!trimmed || trimmed === area.name) {
            setEditing(false);
            setName(area.name);
            return;
        }
        await onUpdate(area.id, trimmed);
        setEditing(false);
    };

    return (
        <div className="areas-modal-item">
            {editing ? (
                <div className="areas-modal-item-edit">
                    <input
                        className="input w-100"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        disabled={busy}
                        autoFocus
                    />
                    <button type="button" className="btn btn-primary btn-sm" disabled={busy || !name.trim()} onClick={() => void save()}>
                        Guardar
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary btn-sm"
                        disabled={busy}
                        onClick={() => {
                            setEditing(false);
                            setName(area.name);
                        }}
                    >
                        Cancelar
                    </button>
                </div>
            ) : (
                <>
                    <div className="areas-modal-item-info">
                        <span className="font-bold">{area.name}</span>
                        {count != null ? (
                            <span className="text-xs text-muted">
                                {Number(count)} colaborador{Number(count) === 1 ? '' : 'es'}
                            </span>
                        ) : null}
                    </div>
                    <div className="areas-modal-item-actions">
                        <button type="button" className="btn btn-outline btn-sm" disabled={busy} onClick={() => setEditing(true)}>
                            Editar
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline btn-sm areas-modal-del"
                            disabled={busy}
                            onClick={() => void onDelete(area)}
                        >
                            Eliminar
                        </button>
                    </div>
                </>
            )}
        </div>
    );
}
